import { DateSelectionValueModel } from 'src/ca-shared/filter-panel/children/date-selection/models/date-selection-value.model';

export class ConversationCleanerFilterDto {
  startTime: Date;
  endTime: Date;
  calledOrCallerNumber: string;
  uniqueCustomerKey: string;
  filterType: string;
}
